<template>
  <div id="contenedor-listado-mobiles">
    <template v-for="(reporte, index) in reportesFisicos">
      <v-card
        :key="index"
        class="mb-2"
        min-height="200"
        flat>
        <v-card-title class="justify-space-between">
          <v-row  justify="space-between">
            <span class="secondary--text">
              #{{ reporte.numero }} {{ $moment(reporte.fecha).format('DD/MM/YYYY') }}
            </span>
            <v-btn
              icon
              @click="mostrarOpciones(reporte)">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </v-row>
        </v-card-title>
        <v-card-text>
          <v-row style="font-weight: bold">
            Comentarios:
          </v-row>
          <v-row>
            <cortar-texto
              :texto="reporte.comentarios"
              :cantidadCaracteres="cantidadCaracteresTexto">
            </cortar-texto>
          </v-row>
          <v-row class="mt-4">
            <template v-if="reporte.existeProblema">
              <v-row justify="start">
                <v-chip
                small
                @click="mostrarProblema(reporte)"
                color="warning">
                  <v-icon class="mr-2"
                  small>
                    warning
                  </v-icon>
                  <span style="font-weight: bold">
                    ¡Existe problema!
                  </span>
                </v-chip>
              </v-row>
            </template>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-chip
          color="naranja2"
          small>
            Programado: {{dosDigitos(reporte.avanceProgramado)}}%
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip
          color="azul1"
          small>
            Avance: {{dosDigitos(limitarAvance(reporte.avanceFisico))}}%
          </v-chip>
          <v-spacer></v-spacer>
          <v-chip
          :color="colorEstatus(getAvanceDiferencia(reporte))"
          :dark="colorEstatus(getAvanceDiferencia(reporte)) === 'red darken-2'"
          small>
          <template
            v-if="reporte.avanceDiferencia < 0">
            Atrazo: {{ dosDigitos((getAvanceDiferencia(reporte) * -1)) }}%
          </template>
          <template
            v-else>
            Atraso: {{ dosDigitos(getAvanceDiferencia(reporte)) }}%
          </template>
        </v-chip>
        </v-card-actions>
      </v-card>
    </template>
    <v-dialog
    v-if="esteReporte" v-model="mostrarVentanaOpciones"
    :width="!$vuetify.breakpoint.xs ? '400' : '90%'">
      <v-card>
        <v-card-title> </v-card-title>
        <v-card-text>
          <v-row>
            <v-col md="4">
              <v-row justify="center">
                <v-btn
                  large
                  color="light-blue"
                  @click="verResporte(esteReporte)"
                >
                  <v-icon color="white">mdi-eye</v-icon>
                </v-btn>
              </v-row>
            </v-col>
            <template
            v-if="esteReporte.numero == reportesFisicos.length && mixValidaScopesActions(2)">
              <v-col md="4">
                <v-row justify="center">
                  <v-btn
                    large
                    color="warning"
                    @click="editarReporteFisico(esteReporte)"
                  >
                    <v-icon color="white"> mdi-pencil </v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </template>
            <template
            v-if="esteReporte.numero == reportesFisicos.length && mixValidaScopesActions(3)">
              <v-col md="4">
                <v-row justify="center">
                  <v-btn
                    large
                    color="red"
                    @click="eliminarReporteFisico(esteReporte)"
                  >
                    <v-icon color="white">mdi-delete</v-icon>
                  </v-btn>
                </v-row>
              </v-col>
            </template>
            </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog
    v-if="mostrarVentanaProblema"
    v-model="mostrarVentanaProblema">
      <v-card>
        <v-card-title class="secondary--text">
          Problemática Reporte # {{esteReporte.numero}}
        </v-card-title>
        <v-card-text>
          {{esteReporte.descripcionProblema}}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { limitarAvanceFisico } from '@/components/administracion/ejecucion/reportes/avanceFisico';
import CortarTexto from '@/components/CortarTextos.vue';
import eventBus from '@/helpers/eventBus';

export default {
  name: 'ListadoMobiles',
  props: {
    reportesFisicos: {
      type: Array,
      required: true,
    },
  },
  components: {
    CortarTexto,
  },
  data() {
    return {
      cantidadCaracteresTexto: 115,
      mostrarVentanaOpciones: false,
      mostrarVentanaProblema: false,
      esteReporte: null,
    };
  },
  methods: {
    limitarAvance: limitarAvanceFisico,
    dosDigitos(num, decimals) {
      return num.toLocaleString('en-US', {
        minimumFractionDigits: decimals || 2,
        maximumFractionDigits: decimals || 2,
      });
    },
    colorEstatus(avanceDiferencia) {
      if (avanceDiferencia <= 5) return 'success';
      if (avanceDiferencia > 5 && avanceDiferencia <= 25) return 'yellow darken-2';
      if (avanceDiferencia > 25) return 'red darken-2';
      return 'success';
    },
    getAvanceDiferencia(reporte) {
      const avanceDiferencia = reporte.avanceProgramado - limitarAvanceFisico(reporte.avanceFisico);
      return avanceDiferencia;
    },
    mostrarProblema(reporte) {
      this.esteReporte = reporte;
      this.mostrarVentanaProblema = true;
    },
    mostrarOpciones(reporte) {
      this.esteReporte = reporte;
      this.mostrarVentanaOpciones = true;
    },
    verResporte(reporte) {
      eventBus.$emit('ver-reporte-fisico', reporte);
    },
    editarReporteFisico(reporte) {
      eventBus.$emit('editar-reporte-fisico', reporte);
    },
    eliminarReporteFisico(reporte) {
      eventBus.$emit('eliminar-reporte-fisico', reporte);
    },
    getColorCalidad(calidad) {
      switch (calidad) {
        case 1:
          // return 'green';
          return 'green lighten-3';
        case 2:
          // return 'amber';
          return 'orange lighten-3';
        default:
          // return 'red';
          return 'red lighten-3';
      }
    },
  },
};
</script>

<style lang="scss">

</style>
